// extracted by mini-css-extract-plugin
module.exports =  {"logoPlaceholder":"LogoPlaceholder-module__logoPlaceholder--t8omT","iconWrap":"LogoPlaceholder-module__iconWrap--siXkG","cryptoImage":"LogoPlaceholder-module__cryptoImage--ir1C9"};